import React from 'react';

function ConditiiUtilizare() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-icon">📜</div>
          <h1>Conditii de Utilizare</h1>
          <p>
            Informatii importante despre utilizarea acestei aplicatii si responsabilitatile utilizatorilor.
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="page-content">
        <div className="page-container">
          
          <div className="content-card legal">
            <h2>1. Despre aceasta aplicatie</h2>
            <p>
              Aceasta aplicatie web ("Aplicatia") este un <strong>instrument de asistenta</strong> pentru 
              completarea formularului de constatare amiabila de accident, dezvoltat si oferit gratuit 
              de <strong>S.C. Autoklasen S.R.L.</strong> ("Autoklasen", "noi").
            </p>
            <p>
              <strong>Aplicatia NU este un serviciu oficial</strong> al statului roman, al Uniunii Europene 
              sau al oricarei institutii guvernamentale. Autoklasen este o companie privata care ofera 
              servicii de constatare daune auto si reparatii.
            </p>
          </div>

          <div className="content-card legal">
            <h2>2. Natura documentului generat</h2>
            <p>
              Formularul PDF generat de aceasta aplicatie reproduce formatul standard european al 
              constatarii amiabile de accident. Cu toate acestea:
            </p>
            <ul>
              <li>Documentul <strong>devine valid doar dupa semnarea olografa</strong> de catre ambii conducatori de vehicule implicati in accident.</li>
              <li>Documentul nesemnat <strong>nu are valoare juridica</strong>.</li>
              <li>Validitatea si acceptarea documentului de catre societatile de asigurare ramane la latitudinea acestora.</li>
              <li>Autoklasen <strong>nu garanteaza</strong> acceptarea documentului de catre orice asigurator.</li>
            </ul>
          </div>

          <div className="content-card legal">
            <h2>3. Limitarea raspunderii</h2>
            <p>
              Prin utilizarea acestei aplicatii, acceptati urmatoarele:
            </p>
            <ul>
              <li><strong>Responsabilitatea datelor:</strong> Intreaga responsabilitate pentru corectitudinea, 
              acuratetea si veridicitatea datelor introduse in formular apartine exclusiv utilizatorilor 
              (conducatorii vehiculelor implicate in accident).</li>
              <li><strong>Fara consultanta juridica:</strong> Aceasta aplicatie NU ofera si NU inlocuieste 
              consultanta juridica profesionala. Pentru situatii complexe, va recomandam sa consultati un avocat.</li>
              <li><strong>Fara raspundere pentru erori:</strong> Autoklasen nu isi asuma raspunderea pentru 
              eventualele erori de completare, omisiuni, sau pentru consecintele utilizarii incorecte a formularului.</li>
              <li><strong>Fara raspundere pentru daune:</strong> Autoklasen nu raspunde pentru nicio dauna 
              directa, indirecta, incidentala sau consecventa rezultata din utilizarea sau imposibilitatea 
              de utilizare a acestei aplicatii.</li>
            </ul>
          </div>

          <div className="content-card legal">
            <h2>4. Protectia datelor personale</h2>
            <p>
              Respectam confidentialitatea datelor dumneavoastra:
            </p>
            <ul>
              <li><strong>Stocare locala:</strong> Toate datele introduse in formular sunt stocate 
              <strong> exclusiv in browserul dumneavoastra</strong> (localStorage), pe dispozitivul 
              dumneavoastra personal.</li>
              <li><strong>Fara transmitere:</strong> Datele personale <strong>NU sunt transmise</strong> 
              catre serverele Autoklasen si NU sunt stocate in nicio baza de date externa.</li>
              <li><strong>Fara colectare:</strong> Nu colectam, nu procesam si nu stocam datele personale 
              introduse in formular.</li>
              <li><strong>Stergere date:</strong> Puteti sterge oricand datele din formular folosind 
              butonul "Reseteaza formularul" sau stergand datele browserului.</li>
              <li><strong>Generare PDF:</strong> La generarea PDF-ului, datele sunt procesate temporar 
              pentru a crea documentul, fara a fi salvate permanent.</li>
            </ul>
          </div>

          <div className="content-card legal">
            <h2>5. Utilizare corespunzatoare</h2>
            <p>
              Constatarea amiabila de accident trebuie utilizata DOAR in situatiile prevazute de lege:
            </p>
            <ul>
              <li>Accidente usoare intre doua vehicule</li>
              <li>Fara vatamari corporale grave</li>
              <li>Ambii conducatori prezenti si de acord cu circumstantele</li>
              <li>Vehicule cu asigurare RCA valida</li>
            </ul>
            <div className="warning-box" style={{marginTop: '20px'}}>
              <p>
                <strong>⚠️ Important:</strong> In caz de vatamari corporale, pagube semnificative, sau neintelegeri intre parti, 
                sunteti obligati sa apelati numarul de urgenta <strong>112</strong> si sa asteptati Politia.
              </p>
            </div>
          </div>

          <div className="content-card legal">
            <h2>6. Proprietate intelectuala</h2>
            <p>
              Aplicatia, designul, codul sursa si toate materialele asociate sunt proprietatea 
              S.C. Autoklasen S.R.L. sau sunt utilizate cu licenta corespunzatoare. 
              Formatul formularului de constatare amiabila este standardul european public.
            </p>
          </div>

          <div className="content-card legal">
            <h2>7. Modificari ale conditiilor</h2>
            <p>
              Ne rezervam dreptul de a modifica aceste conditii de utilizare in orice moment. 
              Modificarile intra in vigoare la momentul publicarii pe aceasta pagina. 
              Continuarea utilizarii aplicatiei dupa publicarea modificarilor constituie 
              acceptarea noilor conditii.
            </p>
          </div>

          <div className="content-card legal">
            <h2>8. Contact</h2>
            <p>
              Pentru orice intrebari legate de aceasta aplicatie sau conditiile de utilizare:
            </p>
            <div className="contact-box">
              <p><strong>S.C. Autoklasen S.R.L.</strong></p>
              <p>Bd. Theodor Pallady 287, Sector 3, Bucuresti</p>
              <p>Telefon: <a href="tel:0371719191">03 71 71 91 91</a></p>
              <p>Email: <a href="mailto:office@autoklasen.ro">office@autoklasen.ro</a></p>
            </div>
          </div>

          <div className="content-card legal">
            <h2>9. Legea aplicabila</h2>
            <p>
              Aceste conditii de utilizare sunt guvernate de legislatia romana. Orice litigiu 
              va fi solutionat de instantele competente din Bucuresti, Romania.
            </p>
          </div>

          <div className="acceptance-box">
            <p>
              Prin utilizarea acestei aplicatii, confirmati ca ati citit, inteles si 
              acceptat aceste conditii de utilizare.
            </p>
          </div>

        </div>
      </div>
    </>
  );
}

export default ConditiiUtilizare;